import type { TypeTableColumn } from '@thefarmersfront/kitchen';

import { TextButtonCell } from '~/components/common';
import { ProductSalesCellRenderer } from '~/components/product';

import { formatDate } from '~/utils/date';

import type { TypeMappingProduct } from '~/types/product.types';

/**
 * [상품 판매처 매핑] 페이지 > 테이블 컬럼 정의
 */
const getProductMappingColumnDefs = ({
  onClickAddSalesChannel,
  onClickViewDetail,
}: {
  onClickAddSalesChannel: (data: TypeMappingProduct) => Promise<void>;
  onClickViewDetail: (data: TypeMappingProduct) => Promise<void>;
}) => {
  const columnDefs: TypeTableColumn<TypeMappingProduct>[] = [
    {
      id: 'no',
      header: 'No',
      cell: ({ row }) => row.index + 1,
      size: 72,
    },
    {
      accessorKey: 'skuActiveType',
      header: '상품 운영 구분',
      size: 120,
    },
    {
      accessorKey: 'skuName',
      header: '컬리 상품명',
      minSize: 240,
      meta: { flex: true },
    },
    {
      accessorKey: 'skuCode',
      header: '컬리 상품코드',
      size: 140,
    },
    {
      accessorKey: 'createdDate',
      header: '상품 등록일',
      size: 100,
      cell: ({ getValue }) => formatDate(getValue<TypeMappingProduct['createdDate']>(), 'YYYY.MM.DD') ?? '-',
    },
    {
      id: 'addSalesChannel',
      header: '',
      minSize: 92,
      size: 92,
      cell: ({ row }) => <ProductSalesCellRenderer onClick={() => onClickAddSalesChannel(row.original)} />,
    },
    {
      accessorKey: 'salesChannelName',
      header: '판매처',
      size: 148,
    },
    {
      accessorKey: 'salesChannelCode',
      header: '판매처 코드',
      size: 140,
    },
    {
      accessorKey: 'salesChannelSkuName',
      header: '판매처 상품명',
      size: 240,
    },
    {
      accessorKey: 'salesChannelSkuCode',
      header: '판매처 상품 코드',
      size: 140,
    },
    {
      id: 'viewDetail',
      header: '',
      minSize: 80,
      size: 80,
      cell: ({ row }) => {
        const data = row.original;
        const hasSalesChannel = Boolean(
          data.salesChannelName && data.salesChannelCode && data.salesChannelSkuName && data.salesChannelSkuCode
        );
        return (
          <TextButtonCell showDashIfNoValue={false} disabled={!hasSalesChannel} onClick={() => onClickViewDetail(data)}>
            상세보기
          </TextButtonCell>
        );
      },
    },
  ];

  return { columnDefs };
};

export default getProductMappingColumnDefs;
